import {
  FilterSearchAndSelect,
  FilterToggle,
  ROLES,
  useGetSectorDataref,
  useGetUppDataref,
  useRoleCheck,
} from "@pharmupp/p3-front-commons"
import { minEntryDateOptions, statusOptions } from "./common"

/** Default adherent filters shared on multiple lists */
export const AdherentDefaultFilters = () => {
  const isAdmin = useRoleCheck(ROLES.ADMIN)
  const isPresident =
    useRoleCheck(ROLES.UPP_PRESIDENT) || useRoleCheck(ROLES.UPP_REPRESENTATIVE)
  const { uppReferential } = useGetUppDataref()
  const { sectorReferential } = useGetSectorDataref()

  return (
    <>
      <FilterToggle name="isUltra" label="Ultra" />
      <FilterToggle name="isNegativeSegmentation" label="Segmentation négative" />
      <FilterSearchAndSelect
        name="minEntryDate"
        label="Ancienneté"
        options={minEntryDateOptions}
        sorted={false}
      />
      {isAdmin && (
        <FilterSearchAndSelect
          name="uppIds"
          label="Upp"
          options={uppReferential}
          multiple
        />
      )}
      {(isAdmin || isPresident) && (
        <FilterSearchAndSelect
          name="sectorIds"
          label="Secteur CDO"
          options={sectorReferential}
          multiple
        />
      )}
      <FilterSearchAndSelect
        name="adherentStatus"
        label="Statut adhérent"
        options={statusOptions}
      />
    </>
  )
}
